import { useChainNameByQuery } from 'state/info/hooks'
import { multiChainId } from 'state/info/constant'
import useSWRImmutable from 'swr/immutable'
import { fetchProtocolData, GLOBAL_DATA } from 'views/Home/data/protocol/thegraph'
import { v3Clients } from 'utils/graphql'

const SWR_SETTINGS_WITHOUT_REFETCH = {
  errorRetryCount: 3,
  errorRetryInterval: 3000,
  keepPreviousData: true,
}

export const useProtocolData = (): { totalVolumeUSD: string; totalValueLockedUSD: string } => {
  const chainName = useChainNameByQuery()
  const chainId = multiChainId[chainName]
  const { data } = useSWRImmutable(
    chainId && [`v3/home/protocol/ProtocolData/${chainId}`, chainId],
    () => fetchProtocolData(v3Clients[chainId]),
    SWR_SETTINGS_WITHOUT_REFETCH,
  )

  // @ts-ignore
  return data
}
